import SgdfParticipantList from './participant-list.component.js';
export * from './participant-list.component.js';
export default SgdfParticipantList;
SgdfParticipantList.define('sgdf-participant-list');
//# sourceMappingURL=participant-list.js.map